module.exports = __webpack_public_path__ + "static/media/carrot.2d01ef3d.png";